import { isHomeRoute } from "./isHomeRoute";

export const HOME_LOADING_CLASS = "home-initial-loading";

export const syncHomeLoadingClass = (isLoading) => {
  if (typeof document === "undefined") return;
  document.documentElement.classList.toggle(HOME_LOADING_CLASS, Boolean(isLoading));
};

export const getInitialHomeLoading = () => {
  if (typeof window === "undefined") return false;
  return isHomeRoute(window.location.pathname);
};
